import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext';
import { PermissionsContext } from '../../context/permissionsContext';

const PermissionRoute = ({ children, module: modulo, action = 'ver' }) => {
  const { isAuthenticated } = useContext(LoginContext);
  const permCtx = useContext(PermissionsContext);
  const hasPermission = permCtx?.hasPermission ?? (() => false);
  const loading = permCtx?.loading ?? false;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (loading) return null;

  if (!hasPermission(modulo, action)) {
    const firstPath = permCtx?.getFirstAdminPath?.();
    return <Navigate to={firstPath || '/administrador/home'} replace />;
  }

  return children;
};

export default PermissionRoute;
